export var createIframe = function () {
    return document.createElement('iframe');
};
//# sourceMappingURL=createIframe.js.map